const MeetingTypeColorIndexes = Object.freeze({
  Recurring: 0,
  Unique: 1,
  External: 2,
  Internal: 1,
});

const timeSpentColorIndexes = {
  "Internal Meetings": MeetingTypeColorIndexes.Internal,
  "External Meetings": MeetingTypeColorIndexes.External,
};

export { timeSpentColorIndexes };

export default MeetingTypeColorIndexes;
